import { render, staticRenderFns } from "./GeneName.vue?vue&type=template&id=31999c86&scoped=true&"
import script from "./GeneName.vue?vue&type=script&lang=js&"
export * from "./GeneName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31999c86",
  null
  
)

export default component.exports